<template>
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      class="st0"
      d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16,12.9l-3.1,0l0,3.1c0,0.5-0.4,1-1,1
	s-1-0.4-1-1v-3.1l-3.1,0c-0.5,0-1-0.4-1-1s0.4-1,1-1l3.1,0V7.9c0-0.5,0.4-1,1-1s1,0.4,1,1V11l3.1,0c0.5,0,1,0.4,1,1
	S16.6,12.9,16,12.9z"
    />
  </svg>
</template>
